import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastService } from 'angular-toastify';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from 'src/app/pages/main.facade';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-pass',
  templateUrl: './pass.component.html',
  styleUrls: ['./pass.component.scss']
})
export class PassComponent implements OnInit, OnDestroy {
  public nfts$: Observable<any>|undefined;
  public approval$: Observable<any>|undefined;
  public season$: Observable<any>|undefined;
  public loading$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  private destroy$ = new Subject();
  selectedCrew:any[]=[];
  showBurn:boolean=false;
  season:any='';
  yyg:any= environment.yyg;
  user:any;
  constructor(private mainfacade:MainFacade, private toast:ToastService)   { }

  ngOnInit(): void {
    this.setSub();
  }

  

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setSub(){
    this.nfts$ = this.mainfacade.nfts$;
    this.approval$ = this.mainfacade.approval$;
    this.season$ = this.mainfacade.season$;
    this.loading$ = this.mainfacade.loading$;
    this.user$ = this.mainfacade.user$;
    this.season$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
        if(message){
          this.season = message;
        }
    });
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
        if(message){
          this.user = message;
        }
    });
  }

  addYYG(token, contract, nft){
    
    let found = this.selectedCrew.findIndex((val)=>{
      return val.token.toLowerCase() === token.toLowerCase() && contract.toLowerCase() === val.contract.toLowerCase();
    });
    
    if(found!== -1){
      this.selectedCrew.splice(found,1);
    }
    else{
      let newCrew = {
        token:token,
        contract:contract
      };
      this.selectedCrew.push(newCrew);
    }
  }

  burn(){
    let ids = [];
    this.selectedCrew.forEach((arr)=>{
      ids.push(arr.token);
    });

    if(ids.length !== 4){
      this.toast.error('Incorrect Crew Selection. Burn only 4 YYG.');
      return;
    }

    this.mainfacade.setLoading(true);
    this.mainfacade.burn(this.user?.Id,ids, this.season?.SeasonId);
    this.showBurn=false;
  }

  isSelected(token,contract){
    return this.selectedCrew.find((val)=>{
      return val.token.toLowerCase() === token.toLowerCase() && contract.toLowerCase() === val.contract.toLowerCase();
    });
  }

  getApproval(){
    this.mainfacade.approval();
  }

}
